<template>
  <div class="content-box">
    <Title />
    <div class="title-right">
      <!-- <el-link href="https://www.100ec.cn/Index/wjsqdws.html" target='_blank'>
        <img src="https://www.100ec.cn/Public/home/images/dd.gif"
      /></el-link> -->
        <el-link href="/zt/cmkxp/" target='_blank'>
        <img src="/zt/cmkxp/img/460.gif"
      /></el-link>
    </div>
    <!-- <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
    >
      <el-menu-item
        :index="String(index + 1)"
        v-for="(i, index) of dataNav"
        :key="index"
        @click="handleSelect(index)"
      >
        {{ i.label }}</el-menu-item
      >
    </el-menu> -->

       <!-- 顶部大类导航 -->
    <el-menu :default-active="activeCategory" class="el-menu-demo category-menu" mode="horizontal" :unique-opened="true">
      <el-menu-item index="0" @click="changeCategory(0)">行业</el-menu-item>
      <el-menu-item index="1" @click="changeCategory(1)">大模型</el-menu-item>
      <el-menu-item index="2" @click="changeCategory(2)">AI 企业</el-menu-item>
      <el-menu-item index="3" @click="changeCategory(3)">AI 应用</el-menu-item>
    </el-menu>

    <!-- 行业子导航 -->
    <el-menu v-if="activeCategory === 0" :default-active="activeIndex" class="el-menu-demo menu-row" mode="horizontal" :unique-opened="true">
      <el-menu-item v-for="(i, index) of dataNavRow1" :key="index" :index="String(index)"
        :class="{ 'is-active': activeIndex === String(index) }" @click="handleSelect(index)">
        {{ i.label }}
      </el-menu-item>
    </el-menu>

    <!-- 模型子导航 -->
    <el-menu v-if="activeCategory === 1" :default-active="activeIndex" class="el-menu-demo menu-row" mode="horizontal" :unique-opened="true">
      <el-menu-item v-for="(i, index) of dataNavRow2" :key="index" :index="String(index)"
        :class="{ 'is-active': activeIndex === String(index) }" @click="handleSelect(index, 1)">
        {{ i.label }}
      </el-menu-item>
    </el-menu>

    <!-- AI 企业子导航 -->
    <el-menu v-if="activeCategory === 2" :default-active="activeIndex" class="el-menu-demo menu-row" mode="horizontal" :unique-opened="true">
      <el-menu-item v-for="(i, index) of dataNavRow3" :key="index" :index="String(index)"
        :class="{ 'is-active': activeIndex === String(index) }" @click="handleSelect(index, 2)">
        {{ i.label }}
      </el-menu-item>
    </el-menu>

    <!-- AI 应用子导航 -->
    <el-menu v-if="activeCategory === 3" :default-active="activeIndex" class="el-menu-demo menu-row" mode="horizontal" :unique-opened="true">
      <el-menu-item v-for="(i, index) of dataNavRow4" :key="index" :index="String(index)"
        :class="{ 'is-active': activeIndex === String(index) }" @click="handleSelect(index, 3)">
        {{ i.label }}
      </el-menu-item>
    </el-menu>

    <div class="mobile-select">
      <el-select v-model="name" @change="handleSelect2">
        <el-option v-for="item in dataNav" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>

    <Textlist />
  </div>
</template>

<script>
export default {
  name: "broadCast",
  data() {
    return {
       activeCategory: 0, // 当前激活的类别 0:行业 1:模型 2:AI 企业 3:AI 应用
      activeIndex: "0", // 当前激活的子项索引
      name: "滚动播报",
      dataNav: [
        {
          value: "AI",
          label: "滚动播报",
        },
        {
          value: "人工智能",
          label: "人工智能",
        },
        {
          value: "大模型",
          label: "大模型",
        },
        {
          value: "智能体",
          label: "智能体",
        },
        {
          value: "机器人",
          label: "机器人",
        },
        {
          value: "具身智能",
          label: "具身智能",
        },
        {
          value: "Deepseek",
          label: "Deepseek",
        },
         {
          value: "chatgpt",
          label: "chatgpt",
        },
        {
          value: "豆包",
          label: "豆包",
        },
        {
          value: "元宝",
          label: "元宝",
        },
        {
          value: "千问",
          label: "千问",
        },
        {
          value: "文心一言",
          label: "文心一言",
        },
        {
          value: "openclaw",
          label: "openclaw",
        },
        {
          value: "KIMI",
          label: "KIMI",
        },
        {
          value: "阿里 AI",
          label: "阿里",
        },
        {
          value: "腾讯 AI",
          label: "腾讯",
        },
        {
          value: "字节 AI",
          label: "字节跳动",
        },
        {
          value: "百度 AI",
          label: "百度",
        },
        {
          value: "美团 AI",
          label: "美团",
        },
        {
          value: "快手 AI",
          label: "快手",
        },
        {
          value: "京东 AI",
          label: "京东",
        },

      ],
       dataNavRow1: [], // 行业
      dataNavRow2: [], // 模型
      dataNavRow3: [], // AI 企业
      dataNavRow4: [], // AI 应用
      params: {
        json: 0,
        filter: [
          // "【",
          "研报",
          "分析",
          "（PPT）",
          "（全文）",
          "曹磊",
          "张周平",
          "董毅智",
          "赵占领",
          "李旻",
        ],
      },
    };
  },
  created() {
    // this.$store.commit("textparams", this.params);
    // this.$store.commit("changeKeys", this.dataNav[0].value);
    // this.$store.dispatch("getText");
    // 拆分三行数据
  // 定义三大类导航数据
    // 定义三大类导航数据
    const industryData = [
      { value: "AI", label: "滚动播报" },
      { value: "人工智能", label: "人工智能" },
      { value: "大模型", label: "大模型" },
      { value: "智能体", label: "智能体" },
      { value: "机器人", label: "机器人" },
      { value: "具身智能", label: "具身智能"},
      { value: "算法 数据", label: "算法" }

    ];
    
    const modelData = [
      { value: "Deepseek", label: "Deepseek" },
      { value: "豆包", label: "豆包" },
      { value: "元宝", label: "元宝" },
      { value: "千问", label: "千问" },
      { value: "文心一言", label: "文心一言" },
      { value: "openclaw", label: "openclaw" },
      { value: "KIMI", label: "KIMI" },
      { value: "chatgpt", label: "chatgpt" }

    ];
    
    const companyData = [
      { value: "阿里 AI", label: "阿里" },
      { value: "腾讯 AI", label: "腾讯" },
      { value: "字节 AI", label: "字节跳动" },
      { value: "华为 AI", label: "华为" },

      { value: "百度 AI", label: "百度" },
      { value: "美团 AI", label: "美团" },
      { value: "快手 AI", label: "快手" },
      { value: "京东 AI", label: "京东" },
      { value: "支付宝 AI", label: "支付宝" }

    ];
    
    const appData = [
      { value: "AI 零售", label: "零售" },
      { value: "AI 跨境", label: "跨境" },
      { value: "AI 教育", label: "教育" },
      { value: "AI 健康", label: "健康" },
      { value: "AI 出行", label: "出行" },
      { value: "AI 生活", label: "生活" },
      { value: "AI 产业", label: "产业" },
      { value: "AI 物流", label: "物流" },
      { value: "AI 金融", label: "金融" }


    ];
    
    this.dataNavRow1 = industryData;
    this.dataNavRow2 = modelData;
    this.dataNavRow3 = companyData;
    this.dataNavRow4 = appData;

    this.$store.commit("textparams", this.params);
    this.$store.commit("changeKeys", this.dataNav[0].value);
    this.$store.dispatch("getText");
  },
  methods: {
    // handleSelect(index) {
    //   if (typeof this.dataNav[index].value == "number") {
    //     this.params.json = 2;
    //   } else {
    //     this.params.json = 0;
    //   }
    //   this.$store.commit("textparams", this.params);
    //   this.$store.commit("changeKeys", this.dataNav[index].value);
    //   this.$store.dispatch("getText");
    // },
    // handleSelect2(value) {
    //   if (typeof value == "number") {
    //     this.params.json = 2;
    //   } else {
    //     this.params.json = 0;
    //   }
    //   this.$store.commit("textparams", this.params);
    //   this.$store.commit("changeKeys", value);
    //   this.$store.dispatch("getText");
    // },
   // 切换类别
    changeCategory(categoryIndex) {
      this.activeCategory = categoryIndex;
      this.activeIndex = "0"; // 重置子项索引为第一个
      
      // 加载对应类别的第一个数据
      let firstValue;
      if (categoryIndex === 0) {
        firstValue = this.dataNavRow1[0].value;
      } else if (categoryIndex === 1) {
        firstValue = this.dataNavRow2[0].value;
      } else if (categoryIndex === 2) {
        firstValue = this.dataNavRow3[0].value;
      } else {
        firstValue = this.dataNavRow4[0].value;
      }
      
      this.$store.commit("changeKeys", firstValue);
      this.$store.dispatch("getText");
    },
    
    handleSelect(index, categoryIndex = 0) {
      // 更新激活索引
      this.activeIndex = String(index);

      let selectedItem;
      if (categoryIndex === 0) {
        selectedItem = this.dataNavRow1[index];
      } else if (categoryIndex === 1) {
        selectedItem = this.dataNavRow2[index];
      } else if (categoryIndex === 2) {
        selectedItem = this.dataNavRow3[index];
      } else {
        selectedItem = this.dataNavRow4[index];
      }

      if (typeof selectedItem.value == "number") {
        this.params.json = 2;
      } else {
        this.params.json = 0;
      }
      this.$store.commit("textparams", this.params);
      this.$store.commit("changeKeys", selectedItem.value);
      this.$store.dispatch("getText");
    },
     handleSelect2(value) {
      // 根据值找到对应的索引
      const index = this.dataNav.findIndex(item => item.value === value);
      if (index !== -1) {
        this.activeIndex = String(index);
      }

      if (typeof value == "number") {
        this.params.json = 2;
      } else {
        this.params.json = 0;
      }
      this.$store.commit("textparams", this.params);
      this.$store.commit("changeKeys", value);
      this.$store.dispatch("getText");
    },
  },
};
</script>
<style scoped>
.title {
  position: relative;
}

.title-right {
  position: absolute;
  left: 195px;
  top: 65px;
}

.title-right img {
  width: 520px;
  height: 70px;
}

@media (max-width: 1100px) {
  .title-right {
    position: static;
    margin: 10px 0;
  }

  .title-right img {
    width: 100%;
    height: 50px;
  }
}

.title {
  position: relative;
}

.title-right {
  position: absolute;
  left: 195px;
  top: 65px;
}

.title-right img {
  width: 520px;
  height: 70px;
}

.menu-row {
  margin-bottom: 5px;
  border-bottom: none;
  background: transparent;
}

.menu-row .el-menu-item {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

.category-menu {
  margin-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
}

.category-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.category-menu .el-menu-item.is-active {
  background-color: #409EFF;
  color: #fff;
}

/* 确保只有当前激活的项有高亮样式 */
.menu-row .el-menu-item.is-active {
  background-color: #ecf5ff;
  color: #409EFF;
}

/* 移除未激活菜单的高亮 */
.menu-row .el-menu-item:not(.is-active) {
  background-color: transparent;
}

@media (max-width: 1100px) {
  .title-right {
    position: static;
    margin: 10px 0;
  }

  .title-right img {
    width: 100%;
    height: 50px;
  }

  /* 移动端隐藏三行菜单，显示下拉选择 */
  .el-menu-demo {
    display: none;
  }

  .mobile-select {
    display: block;
  }
}
</style>